import { ChanelEntryPage } from "./pages/entry/chanel-entry-page";
import { ChanelInvalidPage } from "./pages/invalid/chanel-invalid-page";
import { ChanelQrCodePage } from "./pages/qr-code/chanel-qr-code-page";

export const chanelCustomRoutes = [
  // {
  //   path: "/landing-page",
  //   element: <ChanelLandingPage />,
  // },
  {
    path: "/entry",
    element: <ChanelEntryPage />,
  },
  {
    path: "/invalid",
    element: <ChanelInvalidPage />,
  },
  {
    path: "/qr-code",
    element: <ChanelQrCodePage />,
  },
];
